import styled, { keyframes, css } from 'styled-components';
import { SpinnerProps } from './Spinner';

type StyledSpinnerProps = Omit<SpinnerProps, 'inLine'> & {
  $inLine?: boolean;
};

const spin = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
`;

const primary = css`
  ${({ theme }) => {
    return `border-right: 4px solid ${theme.palette.primary.primary50};
  border-top: 4px solid ${theme.palette.primary.primary500};
  border-left: 4px solid ${theme.palette.primary.primary600};
  border-bottom: 4px solid ${theme.palette.primary.primary700};`;
  }}
`;

const secondary = css`
  ${({ theme }) => {
    return `border-right: 4px solid ${theme.palette.neutral.neutral75};
  border-top: 4px solid ${theme.palette.neutral.surface};
  border-left: 4px solid ${theme.palette.neutral.neutral30};
  border-bottom: 4px solid ${theme.palette.neutral.neutral75};`;
  }}
`;

const absPosition = css`
  left: 25%;
  right: 25%;
  top: 25%;
  bottom: 25%;
  margin: auto;
  position: absolute;
`;

const spinners = {
  primary,
  secondary,
};

export const StyledSpinner = styled.div.withConfig({
  // using the usual check isPropValid() causes an error here, so instead we use a custom check
  // for the prop which we use in the styling
  shouldForwardProp: (prop) => !['variant'].includes(prop),
})<StyledSpinnerProps>`
  animation: ${spin} 0.75s infinite linear;

  box-sizing: border-box;
  border-radius: 50%;
  transition: all 0.3s ease 0s;
  ${({ variant }) => spinners[variant]}
  ${({ size }) => ` height: ${size}; width: ${size};`}
  ${({ $inLine }) => ($inLine ? '' : absPosition)}
`;
